import canvasShare from "./canvasShare.js";
import Hoveredgeshare from "./Hoveredgeshare.js";
import saveCanvas from "./saveCanvas.js";
import sharelinkCopy from "./sharelinkCopy.js";
import sharelink from "./sharelink.js";
import sharepassword from "./sharepassword.js";

export default {
  canvasShare,
  Hoveredgeshare,
  saveCanvas,
  sharelinkCopy,
  sharelink,
  sharepassword,
};
